function determineMismatchedSeats(seats: {
  ny: number;
  non_ny: number;
  reimbursify: number;
  zpm: number;
}) {

  if (!seats) {
    console.log("Seats is undefined.")
    return false;
  }

  const { ny, non_ny, ...others } = seats;
  const combined_seat_based_stripe_seats = {
    combined_marketing_seats: ny + non_ny,
    ...others,
  };

  const nonZeroValues = Object.values(combined_seat_based_stripe_seats).filter(
    (value) => value !== 0
  );

  return new Set(nonZeroValues).size > 1;
}

export default determineMismatchedSeats;
